import { render, staticRenderFns } from "./drawer-booking-event-form.vue?vue&type=template&id=1f2bb838&scoped=true&"
import script from "./drawer-booking-event-form.ts?vue&type=script&lang=ts&"
export * from "./drawer-booking-event-form.ts?vue&type=script&lang=ts&"
import style0 from "./drawer-booking-event-form.scss?vue&type=style&index=0&id=1f2bb838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2bb838",
  null
  
)

export default component.exports